import React from 'react';
import { Link } from 'gatsby';
import { stepsColors } from '../../constants';

const Selector = ({ unlocked, active, onStepChange, toggleModal }) => {
  const steps = stepsColors;

  return (
    <div className="step-selector-container">
      {steps.map((step, i) => {
        const claseBase = 'step-selector ';
        // Allow access to all steps - always use the actual step link and color
        const link = `/etapa/${step.number}`;
        const claseColor = 'step-' + step.color;
        const claseActive =
          active === step.number ? ' step-selector-active' : '';

        const item = (
          <Link
            key={i}
            className={claseBase + claseColor + claseActive}
            to={link}
            onClick={() => onStepChange(step.number)}
          />
        );
        return item;
      })}
    </div>
  );
};

export default Selector;
